<template>
  <div class="border rounded-lg h-10 p-1 bg-white flex gap-x-1 justify-between">
    <div
      v-for="(item, index) in colors"
      :key="index"
      class="h-9 w-9 rounded-lg flex items-center justify-center"
      :class="{
        'bg-background-secondary': selectedIndex === index,
      }"
    >
      <div
        class="h-5 w-5 rounded-full bg-[#ACB3BF] flex items-center justify-center cursor-pointer"
        @click="handleColorClick(item, index)"
      >
        <div
          v-if="item?.color"
          :class="`h-3 w-3 rounded-full shrink-0`"
          :style="`background-color: ${item?.color}`"
        ></div>
        <img v-else :src="item?.img" alt="color" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import colorPlaceholder from "@/assets/colorPlaceholder.png";

const colors = [
  {
    color: "#FFFFFF",
  },
  {
    color: "#000000",
  },
  {
    color: "#266EF1",
  },
  {
    img: colorPlaceholder,
  },
];

const emit = defineEmits(["colorUpdate"]);

const selectedIndex = ref(0);
const isColorPickerSelected = defineModel("isColorPickerSelected", {
  type: Boolean,
  default: false,
});

const handleColorClick = (item, index) => {
  selectedIndex.value = index;
  if (item?.color) {
    emit("colorUpdate", item?.color);
  } else {
    isColorPickerSelected.value = true;
  }
};
</script>
